<template>
  <div
    class="poll-widget-question"
    :style="style"
  >
    <div
      v-if="!widget.isOpinionPoll"
      class="options ri-large-body"
    >
      <div
        v-for="(option, index) in optionsToShow"
        v-show="chosenOption"
        :key="`answered-${option.text}`"
        class="option answered"
        :class="{ 'right-option': option.type === 'true'}"
        @click.stop="optionClicked(option)"
      >
        <check-svg v-show="option.type === 'true'" />
        <x-svg v-show="chosenOption === option.text && option.type === 'false'" />
        <img
          v-show="chosenOption === option.text && option.type === 'na'"
          :src="require('@/assets/icons/question-mark-icon.svg')"
        >
        <div
          v-if="widget.showNumbers"
          v-show="chosenOption !== option.text && option.type !== 'true'"
          class="index"
        >
          <div class="number">
            {{ index + 1 }}
          </div>
        </div>
        <div class="text">
          {{ option.text }}
        </div>
      </div>
      <div
        v-for="(option, index) in optionsToShow"
        v-show="!chosenOption"
        :key="`noanswer-${option.text}`"
        class="option"
        @click.stop="optionClicked(option)"
      >
        <div
          v-if="widget.showNumbers"
          class="index"
        >
          <div class="number">
            {{ index + 1 }}
          </div>
        </div>
        <div class="text">
          {{ option.text }}
        </div>
      </div>
    </div>

    <div
      v-else
      class="options ri-large-body"
    >
      <div
        v-for="(option, index) in optionsToShow"
        :key="option.text"
        class="option"
        :class="{ 'chosen-answer': optionWasChosen(option), answered: chosenOption}"
        @click.stop="optionClicked(option)"
      >
        <div v-if="optionWasChosen(option)">
          <check-svg v-show="option.type === 'true'" />
        </div>
        <div
          v-else-if="widget.showNumbers"
          class="index"
        >
          <div class="number">
            {{ index + 1 }}
          </div>
        </div>
        <div class="text">
          {{ option.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import CheckSvg from './CheckSvg.vue';
import XSvg from './XSvg.vue';

export default {
  name: 'PollWidgetQuestion',
  components: {
    CheckSvg,
    XSvg,
  },
  props: {
    widget: {
      type: Object,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    initialSelected: {
      type: String,
    },
  },
  data() {
    return {
      chosenOption: null,
    };
  },
  computed: {
    style() {
      return {
        background: this.widget.background,
        color: this.widget.color,
      };
    },
    optionsToShow() {
      return _.filter(this.options, option => !!option.type && !!option.text);
    },
  },
  created() {
    this.chosenOption = this.initialSelected;
  },
  methods: {
    optionWasChosen(option) {
      return this.chosenOption === option.text;
    },
    optionClicked(option) {
      if (option.text !== this.chosenOption) {
        this.chosenOption = option.text;
      } else {
        this.chosenOption = '';
      }
      this.$emit('option-clicked', this.chosenOption);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@riseupil/base-ui/src/scss/riseup-colors';
@import '~@riseupil/base-ui/src/scss/border-radius';

.poll-widget-question {
  text-align: right;
  direction: rtl;
  border-radius: 15px;
  overflow: hidden;
  width: 100%;

  .options {
    padding: 16px 24px 0;
    color: $riseup_dark_green;

    .option {
      display: flex;
      background: $riseup_white;
      margin-bottom: 16px;
      border: 1px solid $riseup_dark_green;
      border-radius: $input-field-border-radius;
      padding: 14px 18px 14px 0;

      .index {
        font-size: 14px;
        font-weight: bold;
        margin-left: 10px;
        border: 1px solid $riseup_dark_green;
        border-radius: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 30px;
        width: 30px;
        .number {
          margin-top: 2px;
        }
      }
      .text {
        line-height: 30px;
      }

      &.answered {
        opacity: 0.5;
        &.chosen-answer, &.right-option {
          opacity: 1;
          color: $riseup_white;
          font-weight: bold;
        }

        &.chosen-answer {
          background-color: $riseup_dark_green;
        }

        &.right-option {
          background-color: $riseup_green;
        }

        img, svg {
          height: 30px;
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
